/**
 * Checks if the application is in maintenance mode based on environment variable.
 * If maintenance mode is active, redirects to the maintenance page unless already there.
 * @returns {boolean} True if in maintenance mode, false otherwise
 */
export function checkMaintenanceMode(): boolean {
  try {
    const maintenanceModeValue = String(import.meta.env.VITE_MAINTENANCE_MODE).toLowerCase()
    const inMaintenanceMode = maintenanceModeValue === 'true' || maintenanceModeValue === '1'

    const isMaintenancePage = window.location.pathname.includes('/maintenance')

    if (inMaintenanceMode && !isMaintenancePage) {
      window.location.replace('/maintenance')
      return true
    }

    return inMaintenanceMode
  } catch (error) {
    console.error('Error in checkMaintenanceMode:', error)
    return false
  }
}
